import {
  Backdrop,
  Box,
  Card,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useStyles from "./kitchen_note_popup_styles";
import { useStoreActions, useStoreState } from "easy-peasy";
import Button1 from "../button_1/button_1";
import ModelHeader from "../model_header/model_header";
import { printReceipt, PrintTypes } from "../../printers";

export default function KitchenNotePopup() {
  const classes = useStyles();
  const openKitchenNotePopup = useStoreState(
    (state) => state.openKitchenNotePopup
  );
  const setOpenKitchenNotePopup = useStoreActions(
    (actions) => actions.setOpenKitchenNotePopup
  );
  const selectedOrder = useStoreState((state) => state.selectedOrder);
  const restaurant = useStoreState((state) => state.restaurant);
  const { kitchen_printer_model } = restaurant;

  const [selectedItems, setSelectedItems] = useState({});
  const [isPrinting, setPrinting] = useState(false);

  useEffect(() => {
    if (openKitchenNotePopup && selectedOrder) {
      // Initialize all items as checked only when popup opens
      const initialSelection = {};
      selectedOrder.order_items?.forEach((item) => {
        initialSelection[item.id] = true;
      });
      setSelectedItems(initialSelection);
    }
  }, [openKitchenNotePopup]);

  const onClose = () => {
    setOpenKitchenNotePopup(false);
  };

  const handleToggleItem = (itemId) => {
    setSelectedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const handleSelectAll = () => {
    const allChecked = {};
    selectedOrder.order_items?.forEach((item) => {
      allChecked[item.id] = true;
    });
    setSelectedItems(allChecked);
  };

  const handleDeselectAll = () => {
    const allUnchecked = {};
    selectedOrder.order_items?.forEach((item) => {
      allUnchecked[item.id] = false;
    });
    setSelectedItems(allUnchecked);
  };

  const onPrint = () => {
    const selectedItemIds = Object.keys(selectedItems).filter(
      (id) => selectedItems[id]
    );

    if (selectedItemIds.length === 0) {
      return;
    }

    setPrinting(true);
    printReceipt({
      printerModel: kitchen_printer_model,
      orderOrId: selectedOrder.id,
      directLocal: false,
      currency: restaurant.currency,
      type: PrintTypes.KITCHEN_NOTE,
      selectedItemIds: selectedItemIds.map(Number),
    });

    setTimeout(() => {
      setPrinting(false);
      onClose();
    }, 2000);
  };

  const selectedCount = Object.values(selectedItems).filter(Boolean).length;

  return selectedOrder ? (
    <Backdrop className={classes.backdrop} open={openKitchenNotePopup}>
      <Card className={classes.card}>
        <ModelHeader title="Select Items to Print" onClose={onClose} />
        <div className={classes.content_wrapper}>
          <div className={classes.top_section}>
            <div className={classes.button_row}>
              <button onClick={handleSelectAll} className={classes.select_btn}>
                Select All
              </button>
              <Box width={10} />
              <button
                onClick={handleDeselectAll}
                className={classes.select_btn}
              >
                Deselect All
              </button>
            </div>
          </div>
          <div className={classes.items_container}>
            {selectedOrder.order_items?.map((orderItem) => (
              <FormControlLabel
                key={orderItem.id}
                control={
                  <Checkbox
                    checked={selectedItems[orderItem.id] || false}
                    onChange={() => handleToggleItem(orderItem.id)}
                  />
                }
                label={
                  <div className={classes.item_label}>
                    <span className={classes.item_name}>
                      {orderItem.item.name}
                    </span>
                    <span className={classes.item_qty}>
                      Qty: {orderItem.quantity}
                    </span>
                  </div>
                }
                className={classes.form_control}
              />
            ))}
          </div>
          <div className={classes.bottom_section}>
            <div className={classes.footer}>
              <span className={classes.selected_count}>
                {selectedCount} item{selectedCount !== 1 ? "s" : ""} selected
              </span>
            </div>
            <Box height={10} />
            <div className={classes.button_row}>
              <Button1
                onClick={onPrint}
                isSelected
                title={isPrinting ? "Printing..." : "Print Kitchen Note"}
                disabled={isPrinting || selectedCount === 0}
              />
            </div>
          </div>
        </div>
      </Card>
    </Backdrop>
  ) : (
    <div />
  );
}
